import { Component, OnInit } from '@angular/core';
import { UserDatosService } from 'src/app/services/user/user-datos/user-datos.service';
import { Gtp } from 'src/app/shared/gtp';
import { UserPerfil } from 'src/app/models/user-perfil.model';

@Component({
  selector: 'app-user-perfil',
  templateUrl: './user-perfil.component.html',
  styleUrls: ['./user-perfil.component.scss']
})
export class UserPerfilComponent implements OnInit {

  user;
  loading: boolean = true;

  constructor(
    private gtp: Gtp,
    private userdata: UserDatosService
  ) { }

  ngOnInit(): void {
    this.loadUserData();
  }

  loadUserData(){
    this.userdata.getAccount().subscribe((res)=>{      
      this.user = new UserPerfil(res);
      this.loading = false;
    });
  }

}
